import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getHomepagePageData } from './api';
import type { HomepagePageDataErrorCode } from './types';

export const {
	Context: HomepagePageDataContext,
	Provider: HomepagePageDataContextProvider,
	useContext: useHomepagePageData,
	useAsyncData: useHomepagePageDataFromApi,
	prefetchAsyncData: prefetchHomepagePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'HomepagePageDataContext',
	dataProperty: 'pageData',
	getData: getHomepagePageData,
	hookDeps: ({ locale }) => [locale],
	getUniqueId: ({ locale }) => locale,
	errorHandler: pageDataErrorHandler<HomepagePageDataErrorCode>(),
});
